import { FC } from 'react';
import styles from './index.module.scss';
import { CheckMarkBalloon } from '..';

export const SectionItemPosition: FC = () => {
  return (
    <div className={styles['jobSearchDetail-sectionItem__sectionItemPosition']}>
      <CheckMarkBalloon />
    </div>
  );
};
